import { useResetRootRowsState } from "PFApp/booking/store/provider/resetters/use_reset_root_rows_state";

import { useResetCalendarMetric } from "./use_reset_calendar_metric";
import { useResetCalendarView } from "./use_reset_calendar_view";
import { useResetOrder } from "./use_reset_order";
import { useResetPendingEditsOnGranularityChange } from "./use_reset_pending_edits_on_granularity_change";
import { useResetProjectsView } from "./use_reset_projects_view";

export const useResetters = () => {
  useResetCalendarView();
  useResetProjectsView();
  useResetCalendarMetric();
  useResetOrder();
  useResetRootRowsState();
  useResetPendingEditsOnGranularityChange();
};
